/* istanbul ignore file */
import { boolean as codecBoolean } from 'purify-ts/Codec';
import { utils as coreUtils } from '@codegrade/api-core';
import { parsers } from '@codegrade/utils';
const RenderHtmlEnabledSettingParser = 
/* #__PURE__ */ parsers.object([
    ['name', /* #__PURE__ */ parsers.exactly('RENDER_HTML_ENABLED')],
    ['value', /* #__PURE__ */ parsers.maybeNull(codecBoolean)],
]);
export class RenderHtmlEnabledSetting extends /* #__PURE__ */ coreUtils.AssigningBase {
    static decode(input) {
        return RenderHtmlEnabledSettingParser.decode(input).map(res => new RenderHtmlEnabledSetting(res));
    }
    static unsafeDecode(input) {
        return RenderHtmlEnabledSetting.decode(input).unsafeCoerce();
    }
    static encode(data) {
        return RenderHtmlEnabledSettingParser.encode(data);
    }
    static schema() {
        return RenderHtmlEnabledSettingParser.schema();
    }
}
